<template>
  <div class="benefit-view">
    <navigation-tabs />
    <navigation ref="navigation" />
    <modal-cookies ref="modal-cookies"/>
    <benefit-card-split
        v-if="content"
        :breadcrumb="content.breadcrumb"
        :segment="content.filters.segment"
        :cardType="content.filters.card_type"
        :title="content.title"
        :description="content.description"
        :coverImage="content.cover_image?.data?.attributes?.ext ? getAssetUrl(content.cover_image.data.attributes.url) : null"
        :logoImage="content.logo_image"
        :validDate="content.valid_date"
        :termsAndConditions="content.terms_and_conditions"
        :benefitLink="content.benefit_link"
        :disclaimer="content.disclaimer"
    />
    <feature-vertical-block
        v-if="content.vertical_media && content.vertical_media.media"
        class="benefits"
        :title="content.vertical_media.title"
        :description="content.vertical_media.description"
        :link_text="content.vertical_media.link_text"
        :link="content.vertical_media.link"
        :center="content.vertical_media.center"
        :alternate="content.vertical_media.alternate"
        :bgColor="content.vertical_media.bgColor"
        :marginOff="content.vertical_media.marginOff"
        :imgUrl="imageFormat(content.vertical_media.media.data?.attributes.ext) ? getAssetUrl(content.vertical_media.media.data.attributes.url) : null"
        :videoUrl="videoFormat(content.vertical_media.media.data?.attributes.ext) ? getAssetUrl(content.vertical_media.media.data.attributes.url) : null"
        :anchor_button="content.vertical_media.anchor_button?.[0]"
    />
    <footer-section/>
  </div>
</template>

<script>

// Mixins
import ViewMixin from "@/mixins/viewMixin"

// Components About
import NavigationTabs from '@/components/global/NavigationTabs.vue'
import Navigation from "@/components/global/navigation"
import ModalCookies from "@/components/global/ModalCookies"
import Footer from "@/components/global/footer"
import Header from "@/components/global/header"
import benefitCardSplit from "@/components/benefit/benefit-card-split"
import FeaturesVerticalBlock from "@/components/feature/feature-vertical-block"


export default {
    name: 'benefit',
    mixins: [ViewMixin],
    data: () => {
        return {
            visible: true,

            title: '',
            description: '',
            ogTitle: '',
            ogDescription: '',
            ogImage: '',
            ogImageAlt: '',
            ogImageUrl: ''
        }
    },
    components: {
        'navigation-tabs':NavigationTabs,
        'navigation': Navigation,
        'modal-cookies': ModalCookies,
        'footer-section': Footer,
        'header-section': Header,
        'benefit-card-split': benefitCardSplit,
        'feature-vertical-block': FeaturesVerticalBlock,
    },

    metaInfo() {
        return{
        title: this.title,
        meta: [
            { vmid: 'description', name: 'description', content: this.description },
            { vmid: 'og:title', property: 'og:title', name: 'twitter:title', content: this.ogTitle },
            { vmid: 'og:description', property: 'og:description', name: 'twitter:description', content: this.ogDescription },
            { vmid: 'og:image', property: 'og:image', name: 'twitter:image', itemprop:'image', content: this.ogImage },
            { vmid: 'og:image:secure_url', property: 'og:image:secure_url', name: 'twitter:image', itemprop:'image', content: this.ogImage },
            { vmid: 'og:image:alt',  property: 'og:image:alt', content: this.ogImageAlt },
            { vmid: 'og:url', property: 'og:url', content: this.ogImageUrl },
        ]
        }
    },

    beforeMount() {
        if (this.content && this.content.SEO) {
            const meta = this.content.SEO.meta || [];

            this.title = this.content.SEO.title || '';
            this.description = this.content.SEO.description || '';

            this.ogTitle = meta[0]?.content || '';
            this.ogDescription = meta[1]?.content || '';
            this.ogImage = meta[2]?.content || '';
            this.ogImageAlt = meta[3]?.content || '';
            this.ogUrl = meta[4]?.content || '';
        }
    },

    mounted () {
        this.show()
        this.$refs.navigation.activate("/beneficios")
    },

    beforeDestroy () {
        this.$refs.navigation.forcedLight = false
    },
  
    methods: {
        show(){
            this.$refs.navigation.hidden = false
            this.$refs.navigation.forcedLight = true
        },
        imageFormat(rawFormat){
            switch (true) {
                case (rawFormat === '.png'):
                    return 1
                case (rawFormat === '.jpg'):
                    return 1
                case (rawFormat === '.jpeg'):
                    return 1
                case (rawFormat === '.svg'):
                    return 1
                case (rawFormat === '.gif'):
                    return 1
                default:
                    break;
            }
        },
        videoFormat(rawFormat){
            switch (true) {
                case (rawFormat === '.mp4'):
                    return 1
                case (rawFormat === '.mpeg'):
                    return 1
                default:
                    break;
            }
        }
    },
    computed:{
        content() {
            const id = this.$route.params.id;
            const benefit = this.$store.state.page?.benefits?.[id];
            return benefit?.attributes || null;
        }
    }
}
</script>

<style lang="less" scoped>
@import "../styles/vars.less";

.benefit-view {
    background: @grey-mid;
}
</style>